export const hubspotCalendarUiConstaints = {
    SET_HUBSPOT_CALENDAR_OPEN: 'SET_HUBSPOT_CALENDAR_OPEN',
};
